import React from 'react';
import Link from 'gatsby-link';
import MainNav from '../components/MainNav';
import Avatar from '../components/Avatar';

const generateLink = (lang, currentPath) => {
	let input = '';
	(lang == "GB")?(input = "/en/"):(input = "/it/");
	let isUrlIT, isUrlEN;
    if(currentPath.search('/en/') != -1) {
		isUrlIT = false;
		isUrlEN = true;
	} else {
		isUrlIT = true;
		isUrlEN = false;
	}
	if(isUrlEN) {
		return {
			'en': currentPath,
            'it': currentPath.replace('/en/', '/it/')
		}
	} else {
		return {
			'en': currentPath.replace('/it/', '/en/'),
			'it': currentPath
		}
	}
};

const MainHeader = (props) => (
  <header className="c-main-header">
    <Link
      to={generateLink("GB", props.pathname).en}
      className="c-main-header__logo"
  	>
    <Avatar
    	language="GB"
    	modifierClasses="c-avatar--as-logo"
  	/>
    </Link>

		<Link
			to={generateLink("IT", props.pathname).it}
			className="c-main-header__logo"
			style={{ marginLeft: "5px" }}
		>
    <Avatar
			language="IT"
			modifierClasses="c-avatar--as-logo"
		/>
		</Link>

    <div className="c-main-header__nav">
      <MainNav pathname={props.pathname} />
    </div>
  </header>
    );

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/MainHeader.jsx